export function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

export function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}